// 五大粉圈反应分类内容数据

export interface ReactionCategory {
  slug: string;
  icon: string;
  label: string;
  en: string;
  heat: number;
  trend: string; // 热度走势文案
  summary: string;
  keywords: string[];
  points: string[];
}

export const reactionCategories: ReactionCategory[] = [
  {
    slug: "de-fanning",
    icon: "ri-user-unfollow-line",
    label: "脱粉",
    en: "De-fanning",
    heat: 92,
    trend: "近 24h 讨论量环比 +38%",
    summary:
      "脱粉是塌房后最普遍的第一反应：停止打榜、取关账号、移除置顶、清空超话签到，用沉默完成一次正式告别。",
    keywords: ["取关", "删号", "换头像", "停止打投"],
    points: [
      "取关与移除粉丝牌是最直观的立场信号",
      "旧物料被删或改私密，是脱粉的常见动作",
      "体面脱粉与愤怒取关的边界，往往在评论区显露",
    ],
  },
  {
    slug: "backlash",
    icon: "ri-sparkling-2-line",
    label: "回踩",
    en: "Turning against",
    heat: 88,
    trend: "回踩长文与旧料二创走高",
    summary:
      "回踩是脱粉后的强烈表达：晒出多年消费账目、扒出旧日言行、写万字复盘，主动把曾经的爱转成攻击性物料。",
    keywords: ["晒证据", "小作文", "翻旧账", "锤向"],
    points: [
      "多年消费与应援账目成为回踩最有力的证据",
      "旧综艺、旧采访被逐帧重看，寻找翻车痕迹",
      "回踩内容常具强烈情绪，需要交叉核实",
    ],
  },
  {
    slug: "fanclub",
    icon: "ri-group-2-line",
    label: "后援会",
    en: "Fan club",
    heat: 79,
    trend: "多家后援会声明口径反复",
    summary:
      "塌房后后援会是最先承压的组织：改口径、换管理、发声明再删除，会员的忠诚与组织声誉反复拉扯。",
    keywords: ["联合声明", "换届", "退会潮", "口径"],
    points: [
      "声明的措辞与发布时间，是判断立场的风向标",
      "大粉与普通会员的诉求撕裂，容易引发退会潮",
      "部分后援会以暂停应援避免进一步被反噬",
    ],
  },
  {
    slug: "chaohua",
    icon: "ri-fire-line",
    label: "超话",
    en: "Super topic",
    heat: 84,
    trend: "相关超话签到与热度明显回落",
    summary:
      "超话是粉丝的数据阵地，塌房后签到下滑、主持换血、广场被占，被称作超话失守，成为舆论失守的直观标尺。",
    keywords: ["签到下滑", "换主持", "广场沦陷", "热度回落"],
    points: [
      "签到人数与帖文热度是反应强度的量化指标",
      "主持人立场摇摆会加速话题空间失守",
      "广场讨论从安利转向追问，标志氛围反转",
    ],
  },
  {
    slug: "zhanjie",
    icon: "ri-camera-3-line",
    label: "站姐",
    en: "Station sis",
    heat: 76,
    trend: "头部站子密集处理账号",
    summary:
      "站姐掌握着大量前线物料与信任资产，塌房后往往出现关站、删图、改名或转型考古向的系列动作。",
    keywords: ["关站", "删图", "转型", "清空"],
    points: [
      "删光单人精修图或转私密，往往是关站前兆",
      "高价值物料账号的处置策略，透露不同立场",
      "少数站子以回忆向/考古向姿态完成软退出",
    ],
  },
];

export const reactionCategoriesMeta = {
  title: "五大粉圈反应，一图看懂塌房后的情绪走向",
  description:
    "从脱粉、回踩到后援会、超话与站姐，明星塌房后的每一种反应，都是粉丝立场与舆论体温的直观切片。",
};